import Policies from 'components/policies/Policies';

const PoliciesTab: React.FC = () => {
  return (
    <div>
      <Policies />
    </div>
  );
};

export default PoliciesTab; 